export const addSpacesInNumbers = (num) => {
  if(typeof num === 'number') {
    const reversedString = num.toString().split('').reverse().join('');
    const strWithSpaces = reversedString.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
    return strWithSpaces.split('').reverse().join('')
  }
  return num
}